import React, {useCallback} from 'react'
import {useForm} from 'react-hook-form'
import {api} from '../common/api'
import {ErrorOption} from 'react-hook-form/dist/types/errors'
import {useFormSubmission} from '../common/servercall/useFormSubmission'
import {Box, Grid, IconButton, Stack} from '@mui/material'
import TextInput from '../common/form/TextInput'
import {Cancel, Check} from '@mui/icons-material'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {Spinner} from '../common/components/Spinner'

const schema = yup.object({
    alias: yup.string().trim().max(16, 'too-long')
})

type form = {
    alias: string
}

type props = {
    aliasForm: form,
    productId: string | undefined
    onCancel: () => void
    onSuccess: () => void
}

export const AliasForm = ({aliasForm, onSuccess, onCancel, productId}: props) => {
    const {control, handleSubmit, setError} = useForm({
        resolver: yupResolver(schema),
        defaultValues: {alias: aliasForm.alias},
    })

    const onSubmit = useCallback(
        async (formData: form) => {
            if (!productId) return
            await api.put(`/api/site/${productId}/alias`, {...formData})
            onSuccess()
        },
        [productId, onSuccess],
    )

    const checkError = useCallback(
        (name: any, error: ErrorOption) => {
            setError(name, error)
        },
        [setError],
    )

    const {submit, isSubmitting} = useFormSubmission<form>(onSubmit, checkError)


    return (
        <form onSubmit={handleSubmit(submit)}>
            <Stack direction={'row'}>
                <Grid item xs={12} sm={8} md={6} lg={4} alignSelf={'center'} sx={{marginTop: -2}}>
                    <TextInput readonly={false} label={'Alias'} hideLabel={true} name={'alias'} control={control} required={false}/>
                </Grid>
                {
                    isSubmitting ?
                        <Box alignSelf={'center'} sx={{marginLeft: 2}}>
                            <Spinner size={16}/>
                        </Box> :
                        <>
                            <Box alignSelf={'center'} sx={{marginLeft: 1}}>
                                <IconButton type={'submit'} size={'small'} color='success'
                                            aria-label='Change alias'>
                                    <Check/>
                                </IconButton>
                            </Box>
                            <Box alignSelf={'center'} sx={{marginLeft: 1}}>
                                <IconButton size={'small'} color='secondary' aria-label='Cancel' onClick={onCancel}>
                                    <Cancel/>
                                </IconButton>
                            </Box>
                        </>

                }

            </Stack>
        </form>
    )
}